// src/modules/billing/api.js
import API from "../../services/api";

// Fetch all bills with search and pagination support
export const fetchSchemeList = async ({
  search = "",
  page = 1,
  limit = 10,
}) => {
  try {
    const response = await API.get("schemes/getAllSchemes", {
      params: {
        search,
        page,
        limit,
      },
    });
    console.log(JSON.stringify(response));
    return response; // Return the response data
  } catch (error) {
    console.error("Error fetching bills:", error);
    return error;
  }
};

export const updateScheme = async ({ id = "", bodyData }) => {
  console.log(" ## updateScheme Id: " + id);
  console.log(" ## bodyData: " + bodyData);
  try {
    const response = await API.post("schemes/updateScheme/" + id, bodyData);
    console.log(JSON.stringify(response));
    return response; // Return the response data
  } catch (error) {
    console.error("Error fetching bills:", error);
    return error;
  }
};

export const deleteScheme = async ({id = ""}) => {
  try {
    const response = await API.post("schemes/deleteScheme/" + id);
    console.log(JSON.stringify(response));
    return response; // refresh table
  } catch (error) {
    return error;
  }
};

export const createScheme = async ({ bodyData }) => {
  try {
    const response = await API.post("schemes/createScheme", bodyData);
    console.log(JSON.stringify(response));
    return response; // Return the response data
  } catch (error) {
    console.error("Error fetching bills:", error);
    return error;
  }
};
